<div class="container">
  <h1 #componentTitleHeader>SUREPARK Member IDs Report {{ locationId }}</h1>
  <div class="content">
    <p-toast key="general-message"></p-toast>

    <div class="card">
      <p-table
        #dt
        [value]="sureparkMembers"
        [rows]="10"
        [paginator]="true"
        [globalFilterFields]="['firstName', 'lastName', 'status', 'formattedIdentifiers']"
        [tableStyle]="{ 'min-width': '75rem' }"
        [rowHover]="true"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[10, 25, 50, 100, 10000]"
        [loading]="loading">

        <ng-template pTemplate="caption">
          <div class="flex justify-content-between flex-wrap">
            <div class="flex align-items-center justify-content-start">
              <span class="p-input-icon-left ml-auto">
                <i class="pi pi-search"></i>
                <input #globalSearchInput pInputText type="text" (input)="filterGlobal($any($event.target).value, 'contains')" placeholder="Search..." />
              </span>
            </div>
            <div class="flex align-items-center justify-content-end">
              <button pButton type="button" icon="pi pi-file" (click)="exportCSV()" class="p-button-success mr-2" label="Export CSV"></button>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="firstName">First Name <p-sortIcon field="firstName"></p-sortIcon></th>
            <th pSortableColumn="lastName">Last Name <p-sortIcon field="lastName"></p-sortIcon></th>
            <th pSortableColumn="startValidity">Start Validity <p-sortIcon field="startValidity"></p-sortIcon></th>
            <th pSortableColumn="endValidity">End Validity <p-sortIcon field="endValidity"></p-sortIcon></th>
            <th>Parked Status</th>
            <th #identifiersColumnHeader>Identifiers</th>
          </tr>
          <tr>
            <th><p-columnFilter type="text" field="firstName"></p-columnFilter></th>
            <th><p-columnFilter type="text" field="lastName"></p-columnFilter></th>
            <th><p-columnFilter type="date" field="startValidity"></p-columnFilter></th>
            <th><p-columnFilter type="date" field="endValidity"></p-columnFilter></th>
            <th>
              <p-columnFilter field="status" matchMode="in" [showMenu]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-multiSelect [ngModel]="value" [options]="statusFilterValues"
                                 placeholder="Any" (onChange)="filter($event.value)" [showToggleAll]="true"
                                 styleClass="p-column-filter">
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </th>
            <th><p-columnFilter type="text" field="formattedIdentifiers"></p-columnFilter></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-member>
          <tr>
            <td>{{ member.firstName }}</td>
            <td>{{ member.lastName }}</td>
            <td>{{ member.startValidity | date:'medium' }}</td>
            <td>{{ member.endValidity | date:'medium' }}</td>
            <td>{{ member.status }}</td>
            <td><div *ngFor="let identifier of member.formattedIdentifiers" class="identifier-item">{{ identifier }}</div></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
